/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_Card_HelpInputs */

const en_eta_window_card_help = /** @type {(inputs: Eta_Window_Card_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the time window when you expect to arrive. The customer is notified.`)
};

const ja_eta_window_card_help = /** @type {(inputs: Eta_Window_Card_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到着予定の時間帯を選択してください。お客様に通知されます。`)
};

const fr_eta_window_card_help = /** @type {(inputs: Eta_Window_Card_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez le créneau de votre arrivée prévue. Le client est notifié.`)
};

const de_eta_window_card_help = /** @type {(inputs: Eta_Window_Card_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das voraussichtliche Ankunftsfenster. Der Kunde wird informiert.`)
};

/**
* | output |
* | --- |
* | "Pick the time window when you expect to arrive. The customer is notified." |
*
* @param {Eta_Window_Card_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_card_help = /** @type {((inputs?: Eta_Window_Card_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_Card_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_card_help(inputs)
	if (locale === "ja") return ja_eta_window_card_help(inputs)
	if (locale === "fr") return fr_eta_window_card_help(inputs)
	return de_eta_window_card_help(inputs)
});